// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "./assets/common.css"
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import store from './store/index';
import "./assets/style.css";
import PicLoading from "./components/PicLoading";
Vue.use(PicLoading);
Vue.component('PicLoading', PicLoading);

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer);
Viewer.setDefaults({
    Options: {
        "inline": true,
        "button": true,
        "navbar": true,
        "title": true,
        "toolbar": true,
        "tooltip": true,
        "movable": true,
        "zoomable": true,
        "rotatable": true,
        "scalable": true,
        "transition": true,
        "fullscreen": true,
        "keyboard": true,
        "url": "data-source"
    }
})
// import "./assets/style-mob.css";
iView.Message.config({
    top: 150,
    duration: 3
});
Vue.use(iView);



Vue.config.productionTip = false

iView.Message.config({
    top: 150,
    duration: 3
});

router.beforeEach((to, from, next) => {
    store.dispatch('setRouterName', to.name);
    next();
});

// 跳转后返回顶部
router.afterEach((to, from) => {
    window.scrollTo(0, 0);
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js